import { FiFileText } from 'react-icons/fi';
import type { NavItem } from '@/app/config/navigation';

/**
 * Agreements module manifest.
 *
 * THE PERMISSION CODES ARE THE API'S
 * ----------------------------------
 * The subject codes (`agreement.read`, `agreement.accept`, `agreement.sign`,
 * `agreement.execution.read`) are TENANT authority: they are held by a member of the
 * tenant whose agreements are in question. The platform codes
 * (`platform.agreement.*`) are PLATFORM authority: they are held by a platform operator
 * and never by a tenant administrator.
 *
 * The two axes are never merged. A page renders the tenant surface always, and the
 * platform surface only for an actor who holds a platform grant.
 */
export const AGREEMENT_READ_PERMISSION = 'agreement.read';
export const AGREEMENT_ACCEPT_PERMISSION = 'agreement.accept';
export const AGREEMENT_SIGN_PERMISSION = 'agreement.sign';
export const AGREEMENT_EXECUTION_READ_PERMISSION = 'agreement.execution.read';

export const PLATFORM_AGREEMENT_DOCUMENT_READ_PERMISSION = 'platform.agreement.document.read';
export const PLATFORM_AGREEMENT_DOCUMENT_WRITE_PERMISSION = 'platform.agreement.document.write';
export const PLATFORM_AGREEMENT_REQUIREMENT_WRITE_PERMISSION =
  'platform.agreement.requirement.write';
export const PLATFORM_AGREEMENT_EXECUTION_READ_PERMISSION = 'platform.agreement.execution.read';
export const PLATFORM_AGREEMENT_EVIDENCE_READ_PERMISSION = 'platform.agreement.evidence.read';

export const MANIFEST = {
  id: 'agreements',
  routes: [
    // Subject surface — tenant authority.
    { path: '/agreements', permission: AGREEMENT_READ_PERMISSION, scope: 'tenant' },
    {
      path: '/agreements/executions/:executionId',
      permission: AGREEMENT_EXECUTION_READ_PERMISSION,
      scope: 'tenant',
    },
    // Platform surface — platform authority.
    {
      path: '/platform/agreements/documents',
      permission: PLATFORM_AGREEMENT_DOCUMENT_READ_PERMISSION,
      scope: 'platform',
    },
    {
      path: '/platform/agreements/documents/new',
      permission: PLATFORM_AGREEMENT_DOCUMENT_WRITE_PERMISSION,
      scope: 'platform',
    },
    {
      path: '/platform/agreements/documents/:documentId',
      permission: PLATFORM_AGREEMENT_DOCUMENT_READ_PERMISSION,
      scope: 'platform',
    },
    {
      path: '/platform/agreements/executions',
      permission: PLATFORM_AGREEMENT_EXECUTION_READ_PERMISSION,
      scope: 'platform',
    },
    {
      path: '/platform/agreements/executions/:executionId',
      permission: PLATFORM_AGREEMENT_EXECUTION_READ_PERMISSION,
      scope: 'platform',
    },
  ],
} as const;

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    id: 'agreements.obligations',
    to: '/agreements',
    label: 'Agreements',
    group: 'Workspace',
    order: 60,
    permissionScope: 'tenant',
    permission: { require: [AGREEMENT_READ_PERMISSION] },
    icon: FiFileText.name,
  },
  {
    id: 'platform.agreements',
    to: '/platform/agreements/documents',
    label: 'Agreements',
    group: 'Platform',
    order: 30,
    permissionScope: 'platform',
    permission: { require: [PLATFORM_AGREEMENT_DOCUMENT_READ_PERMISSION] },
    icon: FiFileText.name,
  },
];
